<section class="flex-col justify-center align-center">
  <mat-card>
    <ng-container *ngIf="submitted">
      <p>
        Your message was sent. Thanks for letting us know.
        <ng-container *ngIf="submittedAnonymous">
          Because this was submitted anonymously, we won't be able to follow up with you directly.
        </ng-container>
        <ng-container *ngIf="!submittedAnonymous">
          We'll follow up by email if we need more information.
        </ng-container>
      </p>
      <p>
        <button mat-raised-button color="primary" type="button" (click)="startNewContact()">
          Submit another message
        </button>
      </p>
    </ng-container>
    <ng-container *ngIf="!submitted">
    <h3>Contact Us</h3>
    <p>
      Questions, concerns, or something that isn't working as expected? Fill out the form below
      and we'll send it to the TERPECA team at admin&#64;terpeca.com. You can use the form for:
    </p>
    <ul class="category-instructions">
      <li *ngFor="let category of categories">
        <b>{{ category }}:</b> {{ categoryDescriptions[category] }}
      </li>
    </ul>
    <p>
      You can also reach us directly at admin&#64;terpeca.com if you prefer.
      For especially sensitive issues, you can email Rich directly at rich&#64;terpeca.com.
    </p>
    <form [formGroup]="formGroup" (ngSubmit)="submit()">
      <p>
        <mat-checkbox formControlName="anonymous">
          Submit anonymously
        </mat-checkbox>
      </p>
      <p *ngIf="formGroup.value.anonymous" class="anonymous-hint">
        Your name, email, and account information will not be included, and we won't be able to follow up with you.
      </p>
      <ng-container *ngIf="!formGroup.value.anonymous">
        <p>
          <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <mat-label>Your name</mat-label>
            <input type="text" matInput formControlName="name" required maxlength="200">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <mat-label>Your email</mat-label>
            <input type="email" matInput formControlName="email" required maxlength="320">
            <mat-hint>We'll use this if we need to follow up with you.</mat-hint>
            <mat-error *ngIf="formGroup.controls.email.hasError('email')">
              Please enter a valid email address.
            </mat-error>
          </mat-form-field>
        </p>
      </ng-container>
      <p>
        <mat-form-field appearance="fill" subscriptSizing="dynamic">
          <mat-label>Category</mat-label>
          <select matNativeControl formControlName="category" required>
            <option value=""></option>
            <option *ngFor="let category of categories" [value]="category">{{ category }}</option>
          </select>
        </mat-form-field>
      </p>
      <p *ngIf="subjectFields.room !== 'hidden'">
        <mat-form-field appearance="fill" subscriptSizing="dynamic">
          <mat-label>Room involved</mat-label>
          <input type="text" matInput formControlName="room"
                 [required]="subjectFields.room === 'required'" maxlength="300">
        </mat-form-field>
      </p>
      <p *ngIf="subjectFields.company !== 'hidden'">
        <mat-form-field appearance="fill" subscriptSizing="dynamic">
          <mat-label>Company involved</mat-label>
          <input type="text" matInput formControlName="company"
                 [required]="subjectFields.company === 'required'" maxlength="300">
        </mat-form-field>
      </p>
      <p *ngIf="subjectFields.person !== 'hidden'">
        <mat-form-field appearance="fill" subscriptSizing="dynamic">
          <mat-label>Person involved</mat-label>
          <input type="text" matInput formControlName="person"
                 [required]="subjectFields.person === 'required'" maxlength="300">
          <mat-hint *ngIf="subjectFields.person === 'optional'">Contributor, owner, or other individual.</mat-hint>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="fill" subscriptSizing="dynamic">
          <mat-label>Details</mat-label>
          <textarea matInput formControlName="description" required maxlength="10000"
                    cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="5"></textarea>
          <mat-hint>
            Include anything that might help us look into it.
          </mat-hint>
        </mat-form-field>
      </p>
      <p>
        <button mat-raised-button color="primary" type="submit" [disabled]="formGroup.invalid || submitting">
          {{ submitting ? 'Sending...' : 'Send' }}
        </button>
      </p>
    </form>
    </ng-container>
  </mat-card>
</section>
